"use strict";

exports.__esModule = true;
exports.AlertsCreationScreen = void 0;
var _Core = require("../../Core");
var _react = _interopRequireWildcard(require("react"));
var _Device = require("../../Device");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _App = require("../../App");
var _Report = require("../../Report");
var _AlertsCreationContainer = require("./AlertsCreationContainer");
var _AlertsCreationToolbar = require("./AlertsCreationToolbar/AlertsCreationToolbar");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Container = _styledComponents["default"].div.withConfig({
  displayName: "AlertsCreationScreen__Container",
  componentId: "sc-1eggwoo-0"
})(["display:flex;flex-direction:column;height:100vh;width:100%;overflow:hidden;overflow-y:auto;"]);
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "AlertsCreationScreen__Wrapper",
  componentId: "sc-1eggwoo-1"
})(["overflow:hidden;overflow-y:auto;"]);
var AlertsCreationScreen = exports.AlertsCreationScreen = function AlertsCreationScreen(props) {
  var history = props.history;
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var devices = (0, _react.useContext)(_Device.DeviceListContext);
  var _useState = (0, _react.useState)([]),
    dataItems = _useState[0],
    setDataItems = _useState[1];
  var onDataItemSelection = function onDataItemSelection(items) {
    setDataItems(items);
  };
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("AlertsCreationScreen.title", "Alerts Creation")
  }, /*#__PURE__*/_react["default"].createElement(Container, {
    "data-testid": "AlertsCreationScreen.container"
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
    title: translate("AlertsCreationScreen.navbar.title", "Alerts Creation")
  }), /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(_Report.StandardReportDataProvider, {
    timeRangeKind: "singleDay"
  }, /*#__PURE__*/_react["default"].createElement(_AlertsCreationToolbar.AlertsCreationToolbar, {
    devices: devices,
    selected: dataItems,
    onSelect: onDataItemSelection,
    history: history
  }), /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_Core.ComponentSize, null, function (_ref) {
    var width = _ref.width,
      height = _ref.height;
    return /*#__PURE__*/_react["default"].createElement(_AlertsCreationContainer.AlertsCreationContainer, {
      devices: devices,
      dataItems: dataItems.map(function (dataItem) {
        return dataItem.name;
      }),
      width: width - 50,
      height: height
    });
  })))))));
};